import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["newTestForm", "submitButton",
        "xmitTestType", "xtp", "adl", "stfCheckbox",
        "efDate", "efTime", "exDate", "exTime",
        "testDetails"
        
        //, "advancedDetailsList"
    ];

    connect()
    {
        this.newTestFormTarget.addEventListener("submit", e =>
        {
            let testDetails = Array.from(this.newTestFormTarget.querySelector(".tests-new-detail .test-details").children);

            let testType = this.newTestFormTarget.children[1].firstElementChild.querySelector('input[name="test_type"]:checked').value;
            let siteTestFlag = document.getElementById("site_test_flag").checked;

            this.stfCheckboxTarget.value = siteTestFlag ? "1" : "0";

            this.xtpTarget.value = siteTestFlag ? "Both" : "Primary";

            if (testType != "All")
            {
                let testDetailJson = testDetails.map(detail =>
                {
                    let Point = detail.querySelector(".point input").value,
                        EventCode = detail.querySelector(".event-code input").value,
                        ServType = detail.querySelector(".service-type input").value,
                        AreaNum = detail.querySelector(".area input").value,
                        SignalCode = detail.querySelector(".signal-code input").value;

                    return {
                        Point, EventCode, ServType, AreaNum, SignalCode,
                        DevNum: "", SeqNum: "", TestNum: ""
                    }
                })

                this.adlTarget.value = JSON.stringify(testDetailJson);
            }
        })

        setTimeout(() =>
        {
            let now = new Date();
            this.efDateTarget._flatpickr.setDate(now);
            this.efTimeTarget._flatpickr.setDate(now);

            let twoHoursLater = new Date(now.getTime() + 2 * 1000 * 60 * 60);

            this.exDateTarget._flatpickr.setDate(twoHoursLater);
            this.exTimeTarget._flatpickr.setDate(twoHoursLater);
        }, 300);
    }

    handleResponse(event)
	{
		if (event.detail[0].success)
		{
			const createEvent = new CustomEvent("show-toast", { detail: "Test successfully submitted!" });
			window.dispatchEvent(createEvent);
            const clearNewTestEvent = new CustomEvent("clear-new-test");
			window.dispatchEvent(clearNewTestEvent);

            setTimeout(() =>
            {
                this.element.previousElementSibling.querySelector(".goback").firstElementChild.click();
            }, 500);
		}
		else
		{
			const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: " + event.detail[0].error });
			window.dispatchEvent(errorEvent);
		}
	}

    selectTestType(event)
	{
		if (event.currentTarget.value === "All") this.testDetailsTarget.classList.add("hidden");
		else this.testDetailsTarget.classList.remove("hidden");
	}


}